import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
export const getBusinessCompetencyTypes = async (projectId) => {
  const effectiveProjectId = projectId || 'user-competencies';

  // always returns competency types from on businesses. If projectId provided, returns also from business of given project.
  let apiPath = `cards/types/get-competency-types/${effectiveProjectId}`;

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };

  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
